import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircleIcon, XIcon } from 'lucide-react';
import { purchaseNotices } from '../data/content';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeoutId: number;
    const show = () => {
      setOpen(true);
      timeoutId = window.setTimeout(() => {
        setOpen(false);
        setIndex(prev => (prev + 1) % purchaseNotices.length);
        timeoutId = window.setTimeout(show, 9000);
      }, 6000);
    };
    timeoutId = window.setTimeout(show, 6000);
    return () => window.clearTimeout(timeoutId);
  }, [dismissed, index]);
  const notice = purchaseNotices[index];
  return <div className="pointer-events-none fixed bottom-[84px] left-0 z-30 w-full px-3 sm:w-auto sm:max-w-sm sm:px-4" data-id="element-215" data-mp="1cydck3oixs6l">
      <AnimatePresence data-id="element-216" data-mp="1gwuhcgkh2qku">
        {open && !dismissed ? <motion.div initial={{
        opacity: 0,
        y: 12,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.97
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex items-start gap-3 rounded-2xl border border-brand-100 bg-white p-3 shadow-[0_12px_30px_rgba(15,46,28,0.18)]" role="status" data-id="element-217" data-mp="164o8u3t8xzt4">
            <span className="mt-[2px] flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-50" data-id="element-218" data-mp="i81vxj2joh0b">
              <CheckCircleIcon className="h-5 w-5 text-brand-500" aria-hidden="true" data-id="element-219" data-mp="x5u8q3gpirat" />
            </span>
            <div className="min-w-0 flex-1" data-id="element-220" data-mp="s5ydasm2s86v">
              <p className="text-[13px] font-bold leading-snug text-ink" data-id="element-221" data-mp="s4wshwf9c7by">
                {notice.name} ha appena acquistato il Kit Clinico
              </p>
              <p className="mt-0.5 text-[12px] font-medium text-inksoft" data-id="element-222" data-mp="23m6b6gqkavc7">
                {notice.country} · pochi minuti fa
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="-mr-1 -mt-1 rounded-full p-1 text-inksoft transition-colors duration-150 ease-out hover:bg-creamdeep hover:text-ink" aria-label="Chiudi notifica" data-id="element-223" data-mp="2aqxoiw7y6wiy">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-224" data-mp="2pjhltg8f29sh" />
            </button>
          </motion.div> : null}
      </AnimatePresence>
    </div>;
}